import i18n from "i18next"
import { initReactI18next } from "react-i18next"

import config from "./config"

import de from "./locales/de.json"
import en from "./locales/en.json"
import fr from "./locales/fr.json"
import nl from "./locales/nl.json"

i18n.use(initReactI18next).init({
  resources: {
    de: { translation: de },
    en: { translation: en },
    fr: { translation: fr },
    nl: { translation: nl },
  },
  lng: config.default_language,
  fallbackLng: "de",
  interpolation: {
    escapeValue: false,
  },
})

export default i18n
